import React, { useState } from "react";
import { Loader2, KeyRound, LogIn } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

/** Drop-in change password panel used inside both admin and customer dashboards. */
export default function ChangePasswordCard() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirmPwd) { toast.error("Passwords don't match"); return; }
    if (next.length < 6) { toast.error("Password must be 6+ characters"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      setCurrent(""); setNext(""); setConfirmPwd("");
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
    finally { setSaving(false); }
  };

  return (
    <form onSubmit={submit} className="card p-6 max-w-md" data-testid="change-password-card">
      <div className="flex items-center gap-2 mb-1">
        <KeyRound size={18} className="text-blue-400"/>
        <h3 className="text-white font-semibold text-lg" style={{fontFamily:'Outfit'}}>Change password</h3>
      </div>
      <p className="text-slate-400 text-xs mb-4">Pick a strong new password — at least 6 characters.</p>
      <div className="space-y-3">
        <div><label className="label">Current password</label>
          <input type="password" required value={current} onChange={e=>setCurrent(e.target.value)} className="input w-full" data-testid="cp-current"/></div>
        <div><label className="label">New password</label>
          <input type="password" required value={next} onChange={e=>setNext(e.target.value)} className="input w-full" data-testid="cp-new"/></div>
        <div><label className="label">Confirm new password</label>
          <input type="password" required value={confirmPwd} onChange={e=>setConfirmPwd(e.target.value)} className="input w-full" data-testid="cp-confirm"/></div>
      </div>
      <button type="submit" disabled={saving} className="btn-primary mt-5 inline-flex items-center gap-2" data-testid="cp-save">
        {saving ? <Loader2 size={14} className="animate-spin"/> : <LogIn size={14}/>}
        Update password
      </button>
    </form>
  );
}
